import { media, styled, typography } from '@pulse-web-ui/theme';

export const PreviousNamesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviousNameItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviousNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 7px 16px;

  ${media.desktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const MiddleNameField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldHint = styled.span`
  ${typography.regular14};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Separator = styled.hr`
  width: 100%;
  height: 1px;
  margin: 0;
  border: 0;
  background-color: ${({ theme }) => theme.colors.neutral[30]};
`;
